import React from 'react'

const SmartAi = () => {
  return (
    <div className='ms-lg-n8 mb-12 mb-lg-0'>
    <div className='card bg-back shadow-sm border-0 px-lg-6 py-lg-8 p-4' style={{ borderRadius: '30px' }}>
    <div className='text-center text-lg-start py-4 py-lg-0'>
        <div className='fs-t text-warning fw-medium'>
        <span className="iconify text-warning" data-icon="mdi:star-outline" data-width="40" data-height="40"></span>
        {' '}
        <span className='text-gray-800'>Let's Get Started.</span>
        </div>
        <div className='mt-6'>
            <form className='row justify-content-center justify-content-lg-start'>
                <div className="col-lg-9 mb-5">
                <input
                type="text"
                className="form-control form-control-lg border-0 rounded-pill"
                placeholder="What is child/ward Name?"
                value={''}
                required
                />
                </div>

                <div className='col-lg-3 mb-5 d-flex justify-content-center justify-content-lg-start'>
                <button type="submit" className="btn btn-dark btn-lg rounded-pill px-6">
                    <span className='bi bi-arrow-right'></span>
                </button>
                </div>
            </form>
            <form className='d-flex justify-content-center justify-content-lg-start'>
                <div className='text-center text-lg-start'>
                <span className="iconify text-dark" data-icon="mdi:lock-outline" data-width="20" data-height="20"></span>
                <span className='fs-5 text-gray-700'>Your information is safe with us. We never share your data.</span>
                </div>
            </form>
        </div>
    </div>
    </div>
    </div>
  )
}

export default SmartAi